<script>
import {useMenuStore} from "@/js/store/MenuStore.js";
import SocialsListIcons from "@js/components/TopBar/Components/SocialsListIcons.vue";
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";
import IconX from "@js/components/Icons/IconX.vue";
import {Link} from "@inertiajs/vue3";
import FirstPhone from "@js/components/Sections/Links/FirstPhone.vue";
import SecondPhone from "@js/components/Sections/Links/SecondPhone.vue";
import MobileMenuDropdownBlock from "@js/components/Mobile/Components/MobileMenuDropdownBlock.vue";

export default {
    name: "MobileMenu",
    components: {MobileMenuDropdownBlock, SecondPhone, FirstPhone, IconX, IconChevronDown, SocialsListIcons, Link},
    setup() {
        const menuStore = useMenuStore();

        return {menuStore};
    },
};
</script>

<template>
    <div>
        <div class="fixed inset-y-0 left-0 z-50 w-full bg-white shadow-lg transform transition-transform duration-300"
             :class="{ '-translate-x-full': !menuStore.isSidenavOpen, 'translate-x-0': menuStore.isSidenavOpen }">
            <div class="flex flex-col h-full p-4">
                <div>
                    <button @click="menuStore.toggleSidenav" title="Закрыть" aria-label="Закрыть"
                            class="mb-4 rounded-md focus:outline-none float-end">
                        <IconX class="w-6 h-6"/>
                    </button>
                </div>
                <nav class="flex-grow overflow-y-auto max-h-full mb-5">
                    <ul class="space-y-4">
                        <template v-for="(menuItem, itemKey) in menuStore.menuItems" :key="itemKey">
                            <li>
                                <div v-if="menuItem.submenu">
                                    <MobileMenuDropdownBlock :btnText=" menuItem.title" :items="menuItem.submenu"/>
                                </div>
                                <div v-else>
                                    <Link :href="route(menuItem.route_name, menuItem.route_params ?? {})"
                                          class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg group">
                                        <span class="ml-3">
                                            {{ menuItem.title }}
                                        </span>
                                    </Link>
                                </div>
                            </li>
                        </template>
                    </ul>
                </nav>
                <div class="mt-auto">
                    <div class="flex flex-col items-center justify-center">
                        <SocialsListIcons :classes="'w-7 h-7 mb-5 text-[#2D2D2D]'" :space="'space-x-6'"/>
                        <FirstPhone type="button"
                                    class="w-full mt-2 text-[#2D2D2D] border-2 border-indigo-600 font-bold rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2"/>
                        <SecondPhone type="button"
                                     class="w-full mt-2 text-[#2D2D2D] border-2 border-indigo-600 font-bold rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- Overlay -->
        <div v-if="menuStore.isSidenavOpen"
             @click="menuStore.toggleSidenav"
             class="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
    </div>
</template>

<style scoped lang="scss">
.menu-chevron {
    line-height: 1.3;
}
</style>
